import { BaseEditViewStore} from 'core/stores';
import { FacilityOrderTemplateNewFlowUSIntakePortalNoteModalForm } from 'application/facility-order-new-flow-us-intake/forms';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { action } from "mobx";

class FacilityOrderTemplateNewFlowUSIntakePortalNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        const facilityOrderTemplateId = componentProps.modalParams.data.facilityOrderTemplateId;
        super(rootStore, {
            name: 'facility-order-template-us-intake-add-note-modal',
            Form: FacilityOrderTemplateNewFlowUSIntakePortalNoteModalForm,
            id: facilityOrderTemplateId,
            actions: () => {
                return {
                    get: async(id) =>{
                        const response = await facilityOrderTemplateService.get(id);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await facilityOrderTemplateService.updatePortalNote({ ...resource});
                        return response.data;
                    },
                }
            },
            FormClass: FacilityOrderTemplateNewFlowUSIntakePortalNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.refreshPortalNote = this.modalParams.data.refreshPortalNote;
        this.isIntakeReviewed = this.modalParams.data.isIntakeReviewed;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);
            await this.refreshPortalNote(resource.portalNote);
            this.modalParams.close();
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('FACILITY_ORDER_NEW_FLOW.EDIT.TEMPLATE_NOTE.SUCCESS_UPDATE', name);
    }
}

export default FacilityOrderTemplateNewFlowUSIntakePortalNoteModalStore;
